/**
 * The plain-English summary of the Terms and Conditions. Shown at the top of
 * /terms and in the acceptance dialog, so the two can never say different
 * things. It is a convenience, not the Terms — and says so.
 */
function TermsSummary() {
  return (
    <div className="rounded-lg border border-primary-200 bg-primary-50 p-4 space-y-2">
      <p className="text-sm font-semibold text-neutral-900">The short version</p>
      <ul className="list-disc pl-5 space-y-1 text-sm text-neutral-700">
        <li>
          FactreeTech is a software platform. Each Organisation builds its own records and knowledge on it
          and is responsible for what it enters and for the decisions it makes.
        </li>
        <li>
          We do not give agronomic, chemical, horticultural, irrigation, veterinary, legal, employment,
          financial or tax advice. Calculations, forecasts and suggestions are tools, not advice.
        </li>
        <li>
          We do not check whether a cultivar, variety name or licence entered by an Organisation
          infringes Plant Breeder&rsquo;s Rights, patents, trade marks or contracts. That is the
          responsibility of the Organisation that entered it. We review claims to hold the rights in a
          protected cultivar and show whether we have, but a &ldquo;verified&rdquo; mark is a limited check,
          not a guarantee. An Organisation that licenses a cultivar promises it has the right to, and
          covers us if it does not.
        </li>
        <li>
          Trees and plant material bought from or through FactreeTech are sold under separate Tree Sales
          Terms, which include Plant Breeder&rsquo;s Rights, licence and non-propagation obligations. When
          another nursery sells to you on its own account, the sale is between you and that nursery.
        </li>
        <li>
          The safety tools help you run a safety management system along ISO 45001 lines. They do not make
          you compliant, and they do not replace your legal duties under the work health and safety laws of
          each place you operate — including notifying the regulator yourself.
        </li>
        <li>Your data remains yours. You can export it, and we will not sell it.</li>
      </ul>
      <p className="text-xs text-neutral-500">
        This summary is for convenience only. The full Terms are what apply.
      </p>
    </div>
  );
}

export default TermsSummary;
